import { HttpContext } from '@angular/common/http';
import { Component, Inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import {
  ALLOW_ANONYMOUS,
  DA_SERVICE_TOKEN,
  ITokenService,
  SocialService
} from '@delon/auth';
import { _HttpClient } from '@delon/theme';
import { filter } from 'rxjs';
import { N3_PLATFORM_HERO_URL } from 'src/app/core/constants';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
import { SharedModule } from 'src/app/shared/shared.module';
import CountriesJson from 'src/assets/data/countries.json';

import { UserTermsComponent } from '../../routes/passport/user-terms/user-terms.component';

@Component({
  selector: 'layout-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport-light.component.less'],
  providers: [SocialService],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    UserTermsComponent
  ]
})
export class LayoutPassportComponent implements OnInit {
  readonly n3PlatformHeroUrl = N3_PLATFORM_HERO_URL;
  links = [];
  countryOptions: any[] = [];
  fblink: any;
  iglink: any;
  qnelink: any;
  countryCode = 'MY';
  darkModeSwitch = false;
  fragment: string = '';
  logoYW = '';
  logoYB = '';
  today = new Date();
  privacyLink = signal<string>(
    'https://qne.cloud/ph/qne-software-ph-data-privacy-policy/'
  );

  constructor(
    @Inject(DA_SERVICE_TOKEN) private readonly tokenService: ITokenService,
    private readonly fcWidget: FcwidgetService,
    private readonly http: _HttpClient,
    private readonly router: Router
  ) {
    if (window.name === 'qi') {
      this.logoYW =
        'https://cdn.qne.cloud/qca/assets/img/qi/logo-transparent-yellow-white.png';
      this.logoYB =
        'https://cdn.qne.cloud/qca/assets/img/qi/logo-transparent-yellow-blue.png';
    } else {
      this.logoYW =
        'https://cdn.qne.cloud/qca/assets/img/qca/logo-transparent-yellow-white.webp';
      this.logoYB =
        'https://cdn.qne.cloud/qca/assets/img/qca/logo-transparent-yellow-blue.webp';
    }

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        if (this.router.url.includes('register')) {
          this.activeTabTransform = 'translateX(100%)';
        } else {
          this.activeTabTransform = 'translateX(0%)';
        }
      });
  }

  loadPrivacyLink() {
    this.http
      .get('https://ipinfo.io/json', {
        context: new HttpContext().set(ALLOW_ANONYMOUS, true)
      })
      .subscribe({
        next: (res: any) => {
          const countryCode = res?.country;
          this.privacyLink.set(
            countryCode === 'MY'
              ? 'https://qne.com.my/qne-software-my-data-privacy-policy/'
              : 'https://qne.cloud/ph/qne-software-ph-data-privacy-policy/'
          );
        },
        error: () => {}
      });
  }

  onAcademyClicked() {
    window.open(
      'https://qne.cloud/ph/corporate-social-responsibility/',
      '_blank'
    );
  }

  onAboutClicked() {
    if (this.countryCode === 'MY') {
      window.open(
        'https://qne.cloud/my/accounting-software-malaysia/',
        '_blank'
      );
    } else {
      window.open(
        'https://qne.cloud/ph/cloud-accounting-software-for-accountants/',
        '_blank'
      );
    }
  }

  ngOnInit(): void {
    this.tokenService.clear();
    this.countryOptions = [...CountriesJson];
    this.darkModeSwitchClicked();
    this.loadCountry();
    this.loadPrivacyLink();
  }

  activeTabTransform = 'translateX(0%)';

  get companyName() {
    // if (this.countryCode === 'MY') {
    //   return 'QNE OPTIMUM SDN. BHD.'
    // }
    // return 'QNE SOFTWARE SDN. BHD.';
    return 'QNE SOFTWARE MALAYSIA SDN. BHD.';
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  get copyrightYear() {
    return `2022-${this.currentYear}`;
  }

  loadCountry() {
    this.http
      .get(
        'https://ipinfo.io/json',
        {},
        { context: new HttpContext().set(ALLOW_ANONYMOUS, true) }
      )
      .subscribe({
        next: (res: any) => {
          this.countryCode = res?.country;
          let country = this.countryOptions.find(
            o => o.code == this.countryCode
          );
          if (!country) this.countryCode = 'MY';

          this.changeCountry();
          this.fcWidget.preloadWhenReady();
        },
        error: () => {
          this.countryCode = 'PH';
          this.changeCountry();
          this.fcWidget.preloadWhenReady();
        }
      });
  }

  websiteLink() {
    if (this.countryCode === 'MY') {
      return 'https://qne.cloud/my/';
    } else {
      return 'https://www.qne.cloud/ph/';
    }
  }

  changeCountry() {
    this.fcWidget.changeCountry(this.countryCode);

    switch (this.countryCode) {
      case 'PH':
        this.fblink = 'https://www.facebook.com/QNESoftwarePH/';
        this.iglink = 'https://www.instagram.com/qnesoftwareph/';
        this.qnelink = 'https://qne.com.ph/';
        break;
      case 'MM':
        this.fblink = 'https://www.facebook.com/QNESoftwareMyanmar';
        this.iglink = 'https://www.instagram.com/qnesoftwaremy/';
        this.qnelink = 'https://www.qne.com.my/';
        break;
      default:
        this.fblink = 'https://www.facebook.com/qne.software';
        this.iglink = 'https://www.instagram.com/qnesoftwaremy/';
        this.qnelink = 'https://www.qne.com.my/';
        break;
    }
  }

  get widgetReady$() {
    return this.fcWidget.widgetReady$;
  }

  openChat() {
    this.fcWidget.open();
  }

  darkModeSwitchClicked() {
    let url = this.router.url.replace('#darkmode', '');

    if (this.darkModeSwitch) {
      this.router.navigateByUrl(
        url + (url.endsWith('#') ? 'darkmode' : '#darkmode')
      );
      this.fragment = 'darkmode';
    } else {
      this.router.navigateByUrl(url);
      this.fragment = '';
    }
  }
}
